import loadable from '@loadable/component';

export const AvnetworkSiteWrapper = loadable(
  () => import(/* webpackChunkName: "avnetwork-site" */ './AvnetworkSiteWrapper'),
);
